export default "__VITE_ASSET__kGuCDltG__"